var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-2 container mx-auto lg_mt-3 xl_mt-4" }, [
    _c(
      "div",
      {
        staticClass:
          "text-brand-secondary-900 font-bold mx-2_25 md_mx-1 text-4xl md_text-3xl"
      },
      [_vm._v("We curate, you shop")]
    ),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-full md_w-1-2 mt-1_5" }, [
        _c(
          "div",
          { staticClass: "md_ml-1 md_mr-_5" },
          [
            _c(
              "router-link",
              {
                staticClass: "home-curated-img block transition transition-250",
                attrs: {
                  to: {
                    name: "collection",
                    params: {
                      publicName: "market",
                      collectionSlug: "trending",
                      page: "1"
                    }
                  }
                }
              },
              [
                _c("responsive-image", {
                  attrs: {
                    sizes: "(min-width: 768px) 50%, 100vw",
                    "image-object": _vm.leftImg,
                    "alt-text": "Face Coverings"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "w-full md_w-1-2 mt-1_5" }, [
        _c(
          "div",
          { staticClass: "md_mr-1 md_ml-_5" },
          [
            _c(
              "router-link",
              {
                staticClass: "home-curated-img block transition transition-250",
                attrs: {
                  to: {
                    name: "collection",
                    params: {
                      publicName: "market",
                      collectionSlug: "holidays",
                      page: "1"
                    }
                  }
                }
              },
              [
                _c("responsive-image", {
                  attrs: {
                    sizes: "(min-width: 768px) 50%, 100vw",
                    "image-object": _vm.rightImg,
                    "alt-text": "Trending Products"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }